import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons'

import { AuthRoutePathsEnum } from 'Modules/auth/routes/authRouteConfig.types'

import { Icon } from 'Components/Icon/Icon'

export const PasswordlessError = () => {
  return (
    <div className="d-flex flex-column">
      <Icon color="#e3224e" icon={faCircleExclamation} size={32} />
      <span className="mt-3 fs-4">
        <FormattedMessage
          defaultMessage={'We couldn’t log you in. {link} to try again.'}
          id="PortalLogin_passwordless_error"
          values={{
            link: (
              <Link to={`/${AuthRoutePathsEnum.PASSWORDLESS_LOGIN}`}>
                <u>
                  {
                    <FormattedMessage id="PortalLogin_passwordless_error_link" />
                  }
                </u>
              </Link>
            ),
          }}
        />
      </span>
    </div>
  )
}
